import React from "react"
import { Link } from "gatsby"
import Layout from "../Components/Layout"
import Box from "../Components/Box"
import RulesIlliustration from "../assets/images/rules-illiustration.jpg"
import LrtLogoDark from "../assets/svg/lrtl.svg"
import MmoLogoDark from "../assets/svg/Group 36.svg"
import TopIlliustration from "../assets/images/Kameros.png"
import LrtLogo from "../assets/svg/lrtl.svg"
import MmoLogo from "../assets/svg/Group 36.svg"

export default () => (
  <Layout>


    <div className="grid bg-blue" >


      <div className="grid--cell w-67 index--logo mm-height">
        <div className="index--logo-info">
          <div>Invites to participate</div>
          <div className="index--logo-info-logos">
            <a
              href="https://lrt.lt"
              target="_blank"
              rel="noopener noreferrer"
              title="LRT"
            >
              <img height="40px" src={LrtLogoDark} alt="LRT" />
            </a>
            <a
              href="https://www.llri.lt/"
              target="_blank"
              rel="noopener noreferrer"
              title="LLRI"
            >
              <img height="40px" src={MmoLogoDark} alt="MMO" />
            </a>
          </div>
        </div>


        <div className="img-d">
          <img src={TopIlliustration} alt="" style={{maxWidth : "100%"}}/>
        </div>


      </div>

      <div className="grid--cell w-33 ">
        <div className="index--countdown">
          <div className="index--countdown-info">
            <div>Invites to participate</div>
            <div className="index--countdown-info-logos">
              <a
                href="https://lrt.lt"
                target="_blank"
                rel="noopener noreferrer"
                title="LRT"
              >
                <img height="40px" src={LrtLogo} alt="LRT" />
              </a>
              <a
                href="https://www.llri.lt/"
                target="_blank"
                rel="noopener noreferrer"
                title="LLRI"
              >
                <img height="40px" src={MmoLogo} alt="MMO" />
              </a>
            </div>
          </div>



          <div className="index--countdown-completed">
            <h1 className="ended">
              RULES
            </h1>
          </div>




        </div>
      </div>


    </div>


    <div className="rules-page">

      <Box>
        <h1>Rules</h1>

        <div className="text-container">


          <div className="red">ECONQUIZ CAN BE DONE ONLINE</div>
          <p>
            https://ekonomikavisur.lrt.lt/ <br/>
            The Econquiz quiz is free.

          </p>



          <div className="red">DATA IR LAIKAS</div>
          <p>
            From 2022 m. April 19 d. (Tuesday)
          </p>
          <div className="red">HOW TO PARTICIPATE IN THE ECONQUIZ?</div>
          <p>
            Sign up on this page https://ekonomikavisur.lrt.lt/en/registration <br/>
            You can register in advance or before starting the quiz. <br/>
          </p>
          <div className="red">PARTICIPANTS</div>
          <p>
            The Econquiz is open to everyone.
          </p>
          <div className="red">VIKTORINOS UŽDUOTYS IR EIGA</div>
          <p>
            The Econquiz consists of 30 closed-ended questions. <br/>
            Questions have been active April 19 d. <br/>
            Each participant can take the quiz more than once.<br/>
            The questions of the Econquiz were prepared by the Lithuanian Free Market Institute in cooperation with Luminor Bank.
            <br/>
            <br/>
            The questions in the Econquiz are based on the National Economics Exam material.

          </p>



          <div className="red">EVALUATION</div>
          <p>
            1 point is awarded for each correct closed-ended question.
          </p>
          <p>
            Points will not be deducted for incorrect answers. <br/>
            30 minutes are allotted to answer the questions. <br/>
            Correct answers and explanations are provided at the end of the quiz.

          </p>
          <p>
            During the first six weeks of the project, participants will have the opportunity to win prizes established by the sponsors and the Lithuanian Free Market Institute.
          </p>
          <p>
            Prizes can be won by answering the first two times.
          </p>
          <p>
            The prize winners will be chosen based on the results and the time of answering.
          </p>
          <p>
            In the event of a tie, the Organiser reserves the right to select the winner by drawing lots.
          </p>
          <p>
            Winners will be contacted using the contact details provided during registration.
          </p>




          <div className="red">PRIZES</div>

          <p>
            During the first six weeks of the project, participants will have the opportunity to win prizes established by the sponsors and the Lithuanian Free Market Institute.
            </p>
          <p>
            Different prizes will be won each week and will be published by the Lithuanian Free Market Institute and LRT on their Facebook accounts.
          </p>

          <p>
            The best and fastest participant of  Econquiz will be awarded:
            <br/>
            <ul>
              <li>Annual IQ subscriptions.</li>
              <li>Apple Watch smartwatches established by LRT</li>
              <li>JBL Flip 5 Eco speakers by Telia</li>
              <li>The class with the best score on the Econquiz will be awarded a prize from Luminor Bank - the "Digiklasė" Financial Literacy Course.</li>

              <li>The pupil who scored the best result will be awarded with a cash prize of 300 EUR!</li>
              <li>The citizen who scored the best result will be awarded with a cash prize of 300 EUR!</li>
              <li>The student who scored the best result will be awarded with a cash prize of 300 EUR!</li>
              <li>The most active teacher who will attract the most students will win a 400 EUR cash prize! *</li>


            </ul>
          </p>

          <p>
            * The teacher must be registered as a Quiz Ambassador, which can be done by emailing  {" "}
            <a href="mailto:ekonomikavisur@llri.lt" title="ekonomikavisur@llri.lt">
              ekonomikavisur@llri.lt
            </a>. When registering for the test, the teacher's first and last name must be entered in the comments. If the teacher is organising the quiz in different schools, please inform us by email -  {" "}
            <a href="mailto:ekonomikavisur@llri.lt" title="ekonomikavisur@llri.lt">
              ekonomikavisur@llri.lt
            </a>
          </p>



          <div className="red">PRIVACY POLICY</div>
          <p>
            <Link to="/privacy-policy">LRT ir LLRI privatumo politika, slapukų naudojimo tvarka ir taisyklės.</Link>
          </p>


          <div className="red">ADDITIONAL INFORMATION</div>
          <p>
            Econquiz on the website: ekonomikavisur.lrt.lt <br/>
            Lithuanian Free Market Institute website: www.llri.lt <br/>
            Facebook account  {" "} <a href="https://www.facebook.com/laisvosios.rinkos.institutas" title="https://www.facebook.com/laisvosios.rinkos.institutas">
            „Lithuanian Free Market Institute“
          </a>
            <br/>
            E-mail address: {" "} <a href="mailto:ekonomikavisur@llri.lt" title="ekonomikavisur@llri.lt">
            ekonomikavisur@llri.lt
          </a>

          </p>


        </div>
      </Box>
    </div>
  </Layout>
)
